import { createRouter, createWebHistory } from 'vue-router'

import Dashboard from '../views/Dashboard.vue'
import Questions from '../views/Questions.vue'
import Practice from '../views/Practice.vue'
import Login from '../views/Login.vue'
import ExtensionAuth from '../views/ExtensionAuth.vue'
import Groups from '../views/Groups.vue'
import Profile from '../views/Profile.vue'
import { getToken } from '../auth/storage'
import { formatDocumentTitle } from './document-title'

const protectedRoute = title => ({ requiresAuth: true, layout: 'DefaultLayout', title })

const routes = [
  { path: '/', name: 'Dashboard', component: Dashboard, meta: protectedRoute('Dashboard') },
  { path: '/questions', name: 'Questions', component: Questions, meta: protectedRoute('Questions') },
  { path: '/groups', name: 'Groups', component: Groups, meta: protectedRoute('Groups') },
  { path: '/practice', name: 'Practice', component: Practice, meta: protectedRoute('Practice') },
  { path: '/profile', name: 'Profile', component: Profile, meta: protectedRoute('Profile') },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { guest: true, layout: 'AuthLayout', title: 'Sign in' }
  },
  {
    path: '/extension-auth',
    name: 'ExtensionAuth',
    component: ExtensionAuth,
    meta: { public: true, layout: 'AuthLayout', title: 'Connect Extension' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  const token = getToken()
  if (to.matched.some(record => record.meta.requiresAuth) && !token) {
    return { name: 'Login', query: { redirect: to.fullPath } }
  }
  if (to.matched.some(record => record.meta.guest) && token) {
    return { name: 'Dashboard' }
  }
})

router.afterEach((to) => {
  document.title = formatDocumentTitle(to.meta.title)
})

export default router
